
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marchmadness",
      function () {
        return require("private-next-pages/marchmadness/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marchmadness"])
      });
    }
  